import { lazy } from 'react';

export const InvokeAllScriptsButton = lazy(() =>
  import(/* webpackChunkName: "InvokeAllScriptsButton" */ './InvokeAllScriptsButton').then((module) => ({
    default: module.InvokeAllScriptsButton,
  }))
);
